var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 8,
    viewBox: "0 0 4 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80474 0.862254C4.06509 1.1226 4.06509 1.54471 3.80474 1.80506L1.60948 4.00033L3.80474 6.19559C4.06509 6.45594 4.06509 6.87805 3.80474 7.1384C3.54439 7.39875 3.12228 7.39875 2.86193 7.1384L0.195262 4.47173C-0.0650873 4.21138 -0.0650873 3.78927 0.195262 3.52892L2.86193 0.862254C3.12228 0.601905 3.54439 0.601905 3.80474 0.862254ZM0.902369 3.76462L0.666667 4.00033L0.902369 4.23603C0.772194 4.10585 0.772194 3.8948 0.902369 3.76462Z",
    fill: "#7043FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleBackArrow);
export default __webpack_public_path__ + "static/media/purple_back_arrow.6854c31680d8fb8c5ef76dfd37b44325.svg";
export { ForwardRef as ReactComponent };